import { configureStore, combineReducers } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import { apiSlice } from "./apiSlice";
import authReducer from "./slices/authSlice";
import dataReducer from "./slices/dataSlice";
import uiReducer from "./slices/uiSlice";
import chatReducer from "./slices/chatSlice";
import taskReducer from "./slices/taskSlice";
import projectReducer from "./slices/projectSlice";
import employeeReducer from "../features/employees/store/employeeSlice";
import attendanceReducer from "../features/attendance/store/attendanceSlice";
import documentReducer from "./slices/documentSlice";
import designationReducer from "./slices/designationSlice";
import levelReducer from "./slices/levelSlice";

const appReducer = combineReducers({
  [apiSlice.reducerPath]: apiSlice.reducer,
  auth: authReducer,
  data: dataReducer,
  ui: uiReducer,
  chat: chatReducer,
  tasks: taskReducer,
  projects: projectReducer,
  employees: employeeReducer,
  attendance: attendanceReducer,
  documents: documentReducer,
  designations: designationReducer,
  levels: levelReducer,
});

const rootReducer = (state: any, action: any) => {
  if (action.type === "auth/logout") {
    // Keep routing or minimal state if needed, but here we reset all
    state = undefined;
  }
  return appReducer(state, action);
};

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(apiSlice.middleware),
});

setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
